export default {
    list: [513, 514, 324, 501, 1353, 4925, 5292, 6677],
    map: {
        513: '壹心理M站',
        514: '壹心理APP',
        324: '口袋心理APP',
        501: '壹心理PC',
        1353: '平安好医生×壹心理',
        4925: '壹心理支付宝小程序',
        5292: '测评美团小程序渠道',
        6677: '荣耀运动健康集合页',
    }
}



// WEBPACK FOOTER //
// ./src/util/channelIdMap.config.js